import AdminApi from '../services/api';
import swal from 'sweetalert2';
import Loc from "../services/localization";
import session from "../services/session";

/* init */

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default{

    props: ['show', 'date', 'type', 'personalProgramId'],

    data() {
        return {
            locale: LocService,
            isLoading: false,
            visibleImage: false,
            trainings: [],
            successAdd: '',
            hasError: '',
            filter: '',
            selectedType: '',
            selectedDate: '',
            selectedPersonalProgramId: null,
            pagination: {
                page: 1,
                limit: 100,
                totalCount: 0
            },
            model: {
                date: '',
                type: '',
                trainingDefinitionId: 0,
                selectedPersonalProgramId: null
            }
        };
    },

    watch: {
        show: function(val, oldVal) {
            if(val){
                this.visibleImage = this.type === 'PERSONAL';
                this.selectedDate = this.date
                this.selectedType = this.type
                this.selectedPersonalProgramId = this.personalProgramId;
                this.load();
            }

        },
    },


    methods: {
        close() {
            this.reset();
            this.$topnavbar.$emit('closeChooseDefinition')
        },
        chooseItem: chooseItem,
        isActiveMemberShip: isActiveMemberShip,
        formatDate: formatDate,
        addTraining: addTraining,
        checkNullEmpty: checkNullEmpty,
        getStyleActiveMembership: getStyleActiveMembership,
        keymonitor: keymonitor,
        getName: getName,
        getShortDesc: getShortDesc,
        reset:reset,
        load: load,
        isMobile() {
            return window.innerWidth <= 850; // Adjust the breakpoint as needed
        },
        getClassMobile(){
            if(this.isMobile()){
                return 'modal--small'
            }else {
                return 'modal--large'
            }
        },
        modalStyle(){
            if(this.isMobile()){
                return 'color: white; background-color: black;'
            }else {
                return ''
            }
        },
        mainDivStyle(){
            if(this.isMobile()){
                return 'background-color: #1C242D; color: #ffffff;'
            }else {
                return 'background-color: #1C242D; color: #ffffff;'
            }
        },
        tableStyle(){
            if(this.isMobile()){
                return 'min-height: 400px; max-height: calc(100vh - 260px); overflow: auto; padding: 12px;';
            }
            return 'min-height: 400px; max-height: calc(100vh - 220px); overflow: auto; padding: 12px;';
        }
    }
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load();
    }
}

function load() {
    let _self = this;

    let request = {
        page: _self.pagination.page,
        limit: _self.pagination.limit,
        filter: _self.filter,
        type: _self.selectedType
    }

    AdminApiService.getTrainingDefinitions(request)
        .then((response) => {
            _self.trainings = response.data.results;
            _self.pagination.totalCount = response.data.totalCount;
        })
        .catch((error) => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset(){
    this.trainings = []
    this.filter = ''
    this.pagination = {
        page: 1,
        limit: 100,
        totalCount: 0
    }
}

function chooseItem(item){
    this.model = {
        type: this.selectedType,
        date: this.selectedDate,
        trainingDefinitionId: item.id,
        personalProgramId: this.selectedPersonalProgramId
    }
    this.addTraining();
    // this.reset();
    // this.$topnavbar.$emit('onTrainingDefinitionSelected', {item: item, date: this.selectedDate})
}

function isActiveMemberShip(user){
    var currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    const currentTimeInMilliseconds = currentDate.getTime();
    if(currentTimeInMilliseconds > (user.expireDate * 1000 + 10800000)){
        return false;
    }else{
        return true;
    }
}

function getStyleActiveMembership(user){
    if(!this.isActiveMemberShip(user)){
        return 'color: red;'
    }
    return '';
}

function formatDate(date) {
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY')
}

function getName(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.name;
    }else if(item.enName != null && item.enName.length > 0){
        return  item.enName;
    }
    return item.name;
}

function getShortDesc(item){
    if(session.getLocale() === LocService.getDefaultLanguage()){
        return item.shortDescription;
    }else if(item.enShortDescription != null && item.enShortDescription.length > 0){
        return  item.enShortDescription;
    }
    return item.shortDescription;
}

function addTraining() {
    let _self = this;
    AdminApiService.addNewTrainingOfTheDay(this.model)
        .then((response) => {
            swal(LocService.t("label_success"), LocService.t('label_success_added_training_of_the_day'), 'success')
            _self.$topnavbar.$emit('onTrainingDefinitionSelected')
            _self.reset();
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function checkNullEmpty(item){
    if(item == null) return '/';
    if(item.length === 0) return '/';
    return item;
}



// WEBPACK FOOTER //
// ./src/modals/ChooseTrainingDefinition.js